import UIComponent from "../../ui/component";
import { PaymentSuccessBlock } from "./widget-block/PaymentSuccessBlock";
import { PaymentErrorBlock } from "./widget-block/PaymentErrorBlock";
import goals from "../../utils/goals.js";

/**
 * Результат оплаты после возврата браузера из redirect-метода Stripe (Klarna и т.п.).
 * Показывает те же блоки, что и оплата в iframe на ru-версии.
 */
export class PaymentResultWidget extends UIComponent {
    init() {
        try {
            if (this.status === "success") {
                const block = new PaymentSuccessBlock(
                    this.element.querySelector("#PaymentSuccessBlock")
                );
                block.init();
                block.handlePaymentSuccess({
                    links: { account: this.account_url, files: this.files_url },
                });
                goals.reach("paymentSuccess");

                return;
            }

            if (this.status === "fail") {
                const block = new PaymentErrorBlock(
                    this.element.querySelector("#PaymentErrorBlock")
                );
                block.init();
                block.handlePaymentError({ retryUrl: this.retry_url });
                goals.reach("paymentCancelled");
            }
        } catch (error) {
            console.error("PaymentResultWidget init error:", error);
        }
    }
}
